export const TRUST_SIGNALS = [
    "No account is ever public — private by default",
    "No data sold, ever — your story stays yours",
    "Built-in support resources available when you need extra help",
    "Export or delete all your data, anytime",
];
